import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import {
  LongSerializer_getInstance194e4t3ow5wjs as LongSerializer_getInstance,
  FloatSerializer_getInstance2fspe61zbqree as FloatSerializer_getInstance,
  StringSerializer_getInstance2wffkbpdux3h9 as StringSerializer_getInstance,
  DoubleSerializer_getInstance3da4hv5ndgjlx as DoubleSerializer_getInstance,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
  SerializerFactory1qv9hivitncuv as SerializerFactory,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  getBigIntHashCode294hi5bdhtj6e as getBigIntHashCode,
  equals2au1ep9vhcato as equals,
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { LinkedHashMapSerializermaoj2nyji7op as LinkedHashMapSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/CollectionSerializers.mjs';
import { getNumberHashCode2l4nbdcihl25f as getNumberHashCode } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/bitUtils.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance3hlj875zwihx0 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { createSimpleEnumSerializer2guioz11kk1m0 as createSimpleEnumSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Enums.mjs';
import { Instant3cn81rq2kpflk as Instant } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Instant.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { InstantIso8601Serializer_getInstance2sfqqbic5n1oz as InstantIso8601Serializer_getInstance } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/serializers/InstantSerializers.mjs';
import { ContextualSerializer1uidivg94sh5v as ContextualSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/ContextualSerializer.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { Companion_instance1i4n4o7mef2za as Companion_instance } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { get_default1l68fybpthpme as get_default } from '../../DefaultClock.mjs';
import { get_nullable197rfua9r7fsz as get_nullable } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      k2a() {
        return $serializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance() {
  return Companion_instance_0;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.serverhealth.ServerHealth.Memory', this, 5);
        tmp0_serialDesc.a1b('max', false);
        tmp0_serialDesc.a1b('total', false);
        tmp0_serialDesc.a1b('free', false);
        tmp0_serialDesc.a1b('systemAllocated', false);
        tmp0_serialDesc.a1b('usage', false);
        this.w4o_1 = tmp0_serialDesc;
      }
      x4o(encoder, value) {
        var tmp0_desc = this.w4o_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.w14(tmp0_desc, 0, value.o3f_1);
        tmp1_output.w14(tmp0_desc, 1, value.p3f_1);
        tmp1_output.w14(tmp0_desc, 2, value.q3f_1);
        tmp1_output.w14(tmp0_desc, 3, value.r3f_1);
        tmp1_output.x14(tmp0_desc, 4, value.s3f_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.x4o(encoder, value instanceof Memory() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.w4o_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = 0n;
        var tmp5_local1 = 0n;
        var tmp6_local2 = 0n;
        var tmp7_local3 = 0n;
        var tmp8_local4 = 0.0;
        var tmp9_input = decoder.l13(tmp0_desc);
        if (tmp9_input.a14()) {
          tmp4_local0 = tmp9_input.r13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp9_input.r13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp9_input.r13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp9_input.r13(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp9_input.s13(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp9_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp9_input.r13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp9_input.r13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp9_input.r13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp9_input.r13(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp9_input.s13(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp9_input.m13(tmp0_desc);
        return Memory().y4o(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
      }
      az() {
        return this.w4o_1;
      }
      r1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [LongSerializer_getInstance(), LongSerializer_getInstance(), LongSerializer_getInstance(), LongSerializer_getInstance(), FloatSerializer_getInstance()];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
function ServerHealth$Companion$$childSerializers$_anonymous__691kff() {
  return new (LinkedHashMapSerializer())(StringSerializer_getInstance(), $serializer_getInstance_1());
}
var MemoryClass;
function Memory() {
  if (MemoryClass === VOID) {
    class $ {
      constructor(max, total, free, systemAllocated, usage) {
        this.o3f_1 = max;
        this.p3f_1 = total;
        this.q3f_1 = free;
        this.r3f_1 = systemAllocated;
        this.s3f_1 = usage;
      }
      z4o(max, total, free, systemAllocated, usage) {
        return new (Memory())(max, total, free, systemAllocated, usage);
      }
      u3f(max, total, free, systemAllocated, usage, $super) {
        max = max === VOID ? this.o3f_1 : max;
        total = total === VOID ? this.p3f_1 : total;
        free = free === VOID ? this.q3f_1 : free;
        systemAllocated = systemAllocated === VOID ? this.r3f_1 : systemAllocated;
        usage = usage === VOID ? this.s3f_1 : usage;
        return $super === VOID ? this.z4o(max, total, free, systemAllocated, usage) : $super.z4o.call(this, max, total, free, systemAllocated, usage);
      }
      toString() {
        return 'Memory(max=' + this.o3f_1.toString() + ', total=' + this.p3f_1.toString() + ', free=' + this.q3f_1.toString() + ', systemAllocated=' + this.r3f_1.toString() + ', usage=' + this.s3f_1 + ')';
      }
      hashCode() {
        var result = getBigIntHashCode(this.o3f_1);
        result = imul(result, 31) + getBigIntHashCode(this.p3f_1) | 0;
        result = imul(result, 31) + getBigIntHashCode(this.q3f_1) | 0;
        result = imul(result, 31) + getBigIntHashCode(this.r3f_1) | 0;
        result = imul(result, 31) + getNumberHashCode(this.s3f_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Memory()))
          return false;
        if (!(this.o3f_1 === other.o3f_1))
          return false;
        if (!(this.p3f_1 === other.p3f_1))
          return false;
        if (!(this.q3f_1 === other.q3f_1))
          return false;
        if (!(this.r3f_1 === other.r3f_1))
          return false;
        if (!equals(this.s3f_1, other.s3f_1))
          return false;
        return true;
      }
      static y4o(seen0, max, total, free, systemAllocated, usage, serializationConstructorMarker) {
        if (!(31 === (31 & seen0))) {
          throwMissingFieldException(seen0, 31, $serializer_getInstance().w4o_1);
        }
        var $this = createThis(this);
        $this.o3f_1 = max;
        $this.p3f_1 = total;
        $this.q3f_1 = free;
        $this.r3f_1 = systemAllocated;
        $this.s3f_1 = usage;
        return $this;
      }
    }
    initMetadataForClass($, 'Memory', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
    MemoryClass = $;
  }
  return MemoryClass;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        Companion_instance_1 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.i3g_1 = [null, null, null, lazy(tmp_0, ServerHealth$Companion$$childSerializers$_anonymous__691kff), null];
      }
      k2a() {
        return $serializer_getInstance_0();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_1;
function Companion_getInstance_0() {
  if (Companion_instance_1 === VOID)
    new (Companion_0())();
  return Companion_instance_1;
}
var $serializerClass_0;
function $serializer_0() {
  if ($serializerClass_0 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_0 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.serverhealth.ServerHealth', this, 5);
        tmp0_serialDesc.a1b('serverId', false);
        tmp0_serialDesc.a1b('version', false);
        tmp0_serialDesc.a1b('memory', false);
        tmp0_serialDesc.a1b('features', false);
        tmp0_serialDesc.a1b('loadAverageCpu', false);
        this.a4p_1 = tmp0_serialDesc;
      }
      b4p(encoder, value) {
        var tmp0_desc = this.a4p_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_0().i3g_1;
        tmp1_output.a15(tmp0_desc, 0, value.n3g_1);
        tmp1_output.a15(tmp0_desc, 1, value.o3g_1);
        tmp1_output.c15(tmp0_desc, 2, $serializer_getInstance(), value.p3g_1);
        tmp1_output.c15(tmp0_desc, 3, tmp2_cached[3].f2(), value.q3g_1);
        tmp1_output.y14(tmp0_desc, 4, value.r3g_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.b4p(encoder, value instanceof ServerHealth() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.a4p_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = 0.0;
        var tmp9_input = decoder.l13(tmp0_desc);
        var tmp10_cached = Companion_getInstance_0().i3g_1;
        if (tmp9_input.a14()) {
          tmp4_local0 = tmp9_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp9_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp9_input.x13(tmp0_desc, 2, $serializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp9_input.x13(tmp0_desc, 3, tmp10_cached[3].f2(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp9_input.t13(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp9_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp9_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp9_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp9_input.x13(tmp0_desc, 2, $serializer_getInstance(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp9_input.x13(tmp0_desc, 3, tmp10_cached[3].f2(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp9_input.t13(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp9_input.m13(tmp0_desc);
        return ServerHealth().c4p(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
      }
      az() {
        return this.a4p_1;
      }
      r1b() {
        var tmp0_cached = Companion_getInstance_0().i3g_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), StringSerializer_getInstance(), $serializer_getInstance(), tmp0_cached[3].f2(), DoubleSerializer_getInstance()];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_0 = $;
  }
  return $serializerClass_0;
}
var $serializer_instance_0;
function $serializer_getInstance_0() {
  if ($serializer_instance_0 === VOID)
    new ($serializer_0())();
  return $serializer_instance_0;
}
var ServerHealthClass;
function ServerHealth() {
  if (ServerHealthClass === VOID) {
    class $ {
      constructor(serverId, version, memory, features, loadAverageCpu) {
        Companion_getInstance_0();
        this.n3g_1 = serverId;
        this.o3g_1 = version;
        this.p3g_1 = memory;
        this.q3g_1 = features;
        this.r3g_1 = loadAverageCpu;
      }
      d4p(serverId, version, memory, features, loadAverageCpu) {
        return new (ServerHealth())(serverId, version, memory, features, loadAverageCpu);
      }
      t3g(serverId, version, memory, features, loadAverageCpu, $super) {
        serverId = serverId === VOID ? this.n3g_1 : serverId;
        version = version === VOID ? this.o3g_1 : version;
        memory = memory === VOID ? this.p3g_1 : memory;
        features = features === VOID ? this.q3g_1 : features;
        loadAverageCpu = loadAverageCpu === VOID ? this.r3g_1 : loadAverageCpu;
        return $super === VOID ? this.d4p(serverId, version, memory, features, loadAverageCpu) : $super.d4p.call(this, serverId, version, memory, features, loadAverageCpu);
      }
      toString() {
        return 'ServerHealth(serverId=' + this.n3g_1 + ', version=' + this.o3g_1 + ', memory=' + this.p3g_1.toString() + ', features=' + toString(this.q3g_1) + ', loadAverageCpu=' + this.r3g_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.n3g_1);
        result = imul(result, 31) + getStringHashCode(this.o3g_1) | 0;
        result = imul(result, 31) + this.p3g_1.hashCode() | 0;
        result = imul(result, 31) + hashCode(this.q3g_1) | 0;
        result = imul(result, 31) + getNumberHashCode(this.r3g_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ServerHealth()))
          return false;
        if (!(this.n3g_1 === other.n3g_1))
          return false;
        if (!(this.o3g_1 === other.o3g_1))
          return false;
        if (!this.p3g_1.equals(other.p3g_1))
          return false;
        if (!equals(this.q3g_1, other.q3g_1))
          return false;
        if (!equals(this.r3g_1, other.r3g_1))
          return false;
        return true;
      }
      static c4p(seen0, serverId, version, memory, features, loadAverageCpu, serializationConstructorMarker) {
        Companion_getInstance_0();
        if (!(31 === (31 & seen0))) {
          throwMissingFieldException(seen0, 31, $serializer_getInstance_0().a4p_1);
        }
        var $this = createThis(this);
        $this.n3g_1 = serverId;
        $this.o3g_1 = version;
        $this.p3g_1 = memory;
        $this.q3g_1 = features;
        $this.r3g_1 = loadAverageCpu;
        return $this;
      }
    }
    initMetadataForClass($, 'ServerHealth', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
    ServerHealthClass = $;
  }
  return ServerHealthClass;
}
function _get_$cachedSerializer__te6jhj($this) {
  return $this.f3k_1.f2();
}
function HealthStatus$Level$Companion$_anonymous__lytmlb() {
  return createSimpleEnumSerializer('com.lightningkite.lightningserver.serverhealth.HealthStatus.Level', values());
}
var Level_OK_instance;
var Level_WARNING_instance;
var Level_URGENT_instance;
var Level_ERROR_instance;
function values() {
  return [Level_OK_getInstance(), Level_WARNING_getInstance(), Level_URGENT_getInstance(), Level_ERROR_getInstance()];
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      constructor() {
        Companion_instance_2 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.f3k_1 = lazy(tmp_0, HealthStatus$Level$Companion$_anonymous__lytmlb);
      }
      k2a() {
        return _get_$cachedSerializer__te6jhj(this);
      }
      f1c(typeParamsSerializers) {
        return this.k2a();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_2;
function Companion_getInstance_1() {
  Level_initEntries();
  if (Companion_instance_2 === VOID)
    new (Companion_1())();
  return Companion_instance_2;
}
var Level_entriesInitialized;
function Level_initEntries() {
  if (Level_entriesInitialized)
    return Unit_instance;
  Level_entriesInitialized = true;
  Level_OK_instance = Level().h4p('OK', 0, 'green');
  Level_WARNING_instance = Level().h4p('WARNING', 1, 'yellow');
  Level_URGENT_instance = Level().h4p('URGENT', 2, 'orange');
  Level_ERROR_instance = Level().h4p('ERROR', 3, 'red');
  Companion_getInstance_1();
}
function HealthStatus$Companion$$childSerializers$_anonymous__1swe64() {
  return Companion_getInstance_1().k2a();
}
function HealthStatus$Companion$$childSerializers$_anonymous__1swe64_0() {
  var tmp = getKClass(Instant());
  var tmp_0 = InstantIso8601Serializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
var LevelClass;
function Level() {
  if (LevelClass === VOID) {
    class $ extends Enum() {
      static h4p(name, ordinal, color) {
        var $this = this.c4(name, ordinal);
        $this.g4p_1 = color;
        return $this;
      }
    }
    initMetadataForClass($, 'Level', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_1});
    LevelClass = $;
  }
  return LevelClass;
}
var CompanionClass_2;
function Companion_2() {
  if (CompanionClass_2 === VOID) {
    class $ {
      constructor() {
        Companion_instance_3 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, HealthStatus$Companion$$childSerializers$_anonymous__1swe64);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.o3e_1 = [tmp_1, lazy(tmp_2, HealthStatus$Companion$$childSerializers$_anonymous__1swe64_0), null];
      }
      k2a() {
        return $serializer_getInstance_1();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_2 = $;
  }
  return CompanionClass_2;
}
var Companion_instance_3;
function Companion_getInstance_2() {
  if (Companion_instance_3 === VOID)
    new (Companion_2())();
  return Companion_instance_3;
}
var $serializerClass_1;
function $serializer_1() {
  if ($serializerClass_1 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_1 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.serverhealth.HealthStatus', this, 3);
        tmp0_serialDesc.a1b('level', false);
        tmp0_serialDesc.a1b('checkedAt', true);
        tmp0_serialDesc.a1b('additionalMessage', true);
        this.i4p_1 = tmp0_serialDesc;
      }
      j4p(encoder, value) {
        var tmp0_desc = this.i4p_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_2().o3e_1;
        tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.t3e_1);
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 1)) {
          tmp = true;
        } else {
          // Inline function 'com.lightningkite.now' call
          var tmp$ret$0 = get_default(Companion_instance).b1m();
          tmp = !value.u3e_1.equals(tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.u3e_1);
        }
        if (tmp1_output.h15(tmp0_desc, 2) ? true : !(value.v3e_1 == null)) {
          tmp1_output.d15(tmp0_desc, 2, StringSerializer_getInstance(), value.v3e_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.j4p(encoder, value instanceof HealthStatus() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.i4p_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_input = decoder.l13(tmp0_desc);
        var tmp8_cached = Companion_getInstance_2().o3e_1;
        if (tmp7_input.a14()) {
          tmp4_local0 = tmp7_input.x13(tmp0_desc, 0, tmp8_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp7_input.x13(tmp0_desc, 1, tmp8_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp7_input.z13(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp7_input.x13(tmp0_desc, 0, tmp8_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp7_input.x13(tmp0_desc, 1, tmp8_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp7_input.z13(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp7_input.m13(tmp0_desc);
        return HealthStatus().k4p(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      az() {
        return this.i4p_1;
      }
      r1b() {
        var tmp0_cached = Companion_getInstance_2().o3e_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), tmp0_cached[1].f2(), get_nullable(StringSerializer_getInstance())];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_1 = $;
  }
  return $serializerClass_1;
}
var $serializer_instance_1;
function $serializer_getInstance_1() {
  if ($serializer_instance_1 === VOID)
    new ($serializer_1())();
  return $serializer_instance_1;
}
function Level_OK_getInstance() {
  Level_initEntries();
  return Level_OK_instance;
}
function Level_WARNING_getInstance() {
  Level_initEntries();
  return Level_WARNING_instance;
}
function Level_URGENT_getInstance() {
  Level_initEntries();
  return Level_URGENT_instance;
}
function Level_ERROR_getInstance() {
  Level_initEntries();
  return Level_ERROR_instance;
}
var HealthStatusClass;
function HealthStatus() {
  if (HealthStatusClass === VOID) {
    class $ {
      constructor(level, checkedAt, additionalMessage) {
        Companion_getInstance_2();
        var tmp;
        if (checkedAt === VOID) {
          // Inline function 'com.lightningkite.now' call
          tmp = get_default(Companion_instance).b1m();
        } else {
          tmp = checkedAt;
        }
        checkedAt = tmp;
        additionalMessage = additionalMessage === VOID ? null : additionalMessage;
        this.t3e_1 = level;
        this.u3e_1 = checkedAt;
        this.v3e_1 = additionalMessage;
      }
      l4p(level, checkedAt, additionalMessage) {
        return new (HealthStatus())(level, checkedAt, additionalMessage);
      }
      x3e(level, checkedAt, additionalMessage, $super) {
        level = level === VOID ? this.t3e_1 : level;
        checkedAt = checkedAt === VOID ? this.u3e_1 : checkedAt;
        additionalMessage = additionalMessage === VOID ? this.v3e_1 : additionalMessage;
        return $super === VOID ? this.l4p(level, checkedAt, additionalMessage) : $super.l4p.call(this, level, checkedAt, additionalMessage);
      }
      toString() {
        return 'HealthStatus(level=' + this.t3e_1.toString() + ', checkedAt=' + this.u3e_1.toString() + ', additionalMessage=' + this.v3e_1 + ')';
      }
      hashCode() {
        var result = this.t3e_1.hashCode();
        result = imul(result, 31) + this.u3e_1.hashCode() | 0;
        result = imul(result, 31) + (this.v3e_1 == null ? 0 : getStringHashCode(this.v3e_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof HealthStatus()))
          return false;
        if (!this.t3e_1.equals(other.t3e_1))
          return false;
        if (!this.u3e_1.equals(other.u3e_1))
          return false;
        if (!(this.v3e_1 == other.v3e_1))
          return false;
        return true;
      }
      static k4p(seen0, level, checkedAt, additionalMessage, serializationConstructorMarker) {
        Companion_getInstance_2();
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_1().i4p_1);
        }
        var $this = createThis(this);
        $this.t3e_1 = level;
        if (0 === (seen0 & 2)) {
          var tmp = $this;
          // Inline function 'com.lightningkite.now' call
          tmp.u3e_1 = get_default(Companion_instance).b1m();
        } else
          $this.u3e_1 = checkedAt;
        if (0 === (seen0 & 4))
          $this.v3e_1 = null;
        else
          $this.v3e_1 = additionalMessage;
        return $this;
      }
    }
    initMetadataForClass($, 'HealthStatus', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_1});
    HealthStatusClass = $;
  }
  return HealthStatusClass;
}
//region block: init
Companion_instance_0 = new (Companion())();
//endregion
//region block: exports
export {
  Level as Level3nkvlyj1o3kmm,
  HealthStatus as HealthStatusyf3nmc52arsb,
  Memory as Memory2d9txv6h117z7,
  ServerHealth as ServerHealth2sa34lcpyf5qz,
  Companion_getInstance_2 as Companion_getInstance3m865vivtv009,
  Companion_getInstance_1 as Companion_getInstance3i96z74mcv2y1,
  Companion_getInstance_0 as Companion_getInstance7ri1umalrfbk,
  Companion_instance_0 as Companion_instance1y2fclwwulp17,
};
//endregion

//# sourceMappingURL=HealthStatus.mjs.map
